module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 1994 R.C.S. Libri & Grandi Opere SpA-Milano")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("English translation copyright © 1995 by Houghton Mifflin Harcourt")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved. For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("This is a translation of "), _c('em', [_vm._v("L’Isola del Giorno Prima.")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("The Library of Congress has cataloged the hardcover edition as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Eco, Umberto."), _c('br'), _vm._v("\n[Isola del giorno prima. English]"), _c('br'), _vm._v("\nThe island of the day before/by Umberto Eco;"), _c('br'), _vm._v("\ntranslated from the Italian by William Weaver.—1st ed."), _c('br'), _vm._v("\np. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("I. Weaver, William, 1923– . II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("PQ4865.C6I8413 1995"), _c('br'), _vm._v("\n853'.914—dc20 95-7594")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("ISBN-13: 978-0-15-100151-4 ISBN-10: 0-15-100151-0")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("ISBN-13: 978-0-15-603037-3 (pbk.) ISBN-10: 0-15-603037-3 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("eISBN 978-0-547-56389-3"), _c('br'), _vm._v("\nv2.0620")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0223e7e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0